(() => {
    if (!window.__customPgSoldOutCross) {
      const updateRoot = (root) => {
        if (!root) return;
        const variantJson = root.querySelector('.custom-pg-variants-json');
        if (!variantJson) return;

        let variants = [];
        try {
          variants = JSON.parse(variantJson.textContent || '[]');
        } catch (error) {
          return;
        }

        const checkedValues = {};
        root.querySelectorAll('.custom-pg-variant-option-input:checked').forEach((input) => {
          checkedValues[input.dataset.optionPosition] = input.value;
        });

        root.querySelectorAll('.custom-pg-variant-option-input').forEach((input) => {
          const optionPosition = Number(input.dataset.optionPosition || '0');
          const hasAvailableVariant = variants.some((variant) => {
            if (!variant.available) return false;

            for (let index = 1; index <= 3; index += 1) {
              const expectedValue = index === optionPosition ? input.value : checkedValues[String(index)] || checkedValues[index];
              if (expectedValue && variant['option' + index] !== expectedValue) {
                return false;
              }
            }

            return true;
          });

          const label = input.nextElementSibling;
          if (!label) return;
          label.classList.toggle('is-sold-out', !hasAvailableVariant);
        });
      };

      window.__customPgSoldOutCross = {
        updateAll(scope = document) {
          if (scope.matches && scope.matches('.custom-quick-view-popup-info')) {
            updateRoot(scope);
            return;
          }
          scope.querySelectorAll('.custom-quick-view-popup-info').forEach(updateRoot);
        }
      };

      document.addEventListener('change', (event) => {
        if (!event.target.matches('.custom-pg-variant-option-input')) return;
        window.__customPgSoldOutCross.updateAll(event.target.closest('.custom-quick-view-popup-info') || document);
      });
    }

    window.__customPgSoldOutCross.updateAll();
    document.addEventListener('collection:updated', () => window.__customPgSoldOutCross.updateAll());
    document.addEventListener('shopify:section:load', event => window.__customPgSoldOutCross.updateAll(event.target));
  })();

document.addEventListener('click', event => {
  const trigger = event.target.closest('.custom-pg-quick-view-btn');
  if (!trigger) return;
  const card = trigger.closest('.jci-product-card-wrapper');
  const template = card?.querySelector('.jci-quick-view-template');
  if (template) {
    template.replaceWith(template.content.cloneNode(true));
    window.__customPgSoldOutCross.updateAll(card);
  }
  const gallery = card?.querySelector('swiper-container[init="false"]');
  if (gallery) customElements.whenDefined('swiper-container').then(() => {
    if (!gallery.swiper) gallery.initialize();
    else gallery.swiper.update();
  });
  card?.querySelectorAll('img[data-jci-src]').forEach(image => {
    image.srcset = image.dataset.jciSrcset;
    image.src = image.dataset.jciSrc;
    delete image.dataset.jciSrcset;
    delete image.dataset.jciSrc;
  });
}, true);
